<style scoped>
@import url(../../style/home/homepage.css);
@import url(../../style/home/product-section.css);
@import url(../../style/home/product-section-hover.css);
@import url(../../style/home/innovation-module.css);
@import url(../../style/home/news-center.css);
@import url(../../style/home/about-us.css);
@import url(../../style/home/user-service.css);
@import url(../../style/home/partner-section.css);
@import url(../../style/home/footer.css);
</style>

<template>
  <div class="home-container">
    <!-- 导入头部导航组件 -->
    <AppHeader />


    <!-- 主要内容区 大图背景模块-->
    <main class="main-content scroll-reveal">
      <img class="bg-img" src="https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731160938656.jpg" alt="首页背景" />
      <div class="text-content">
        <h1>千手医疗皮肤镜正式上市 全球发售</h1>
        <p>以科技之力守护皮肤健康</p>
      </div>
    </main>

    <!-- 产品及应用方案 -->
    <div class="product-section scroll-reveal">
      <!-- 左侧区域：标题、描述、按钮 -->
      <div class="left-column">
        <div class="left-column__top">
          <h1>产品及应用方案</h1>
          <div class="module-underline"></div>
          <p>一家致力于高科技医疗电子产品研发、生产及销售服务的高科技企业！</p>
        </div>
        <div class="buttons-container">
          <button class="action-btn" @click="handleMoreProducts">点击了解更多产品</button>
          <button class="action-btn" @click="handleMoreSolutions">点击了解更多移动应用</button>
        </div>
      </div>

      <!-- 右侧区域：产品展示区 -->
      <div class="right-column">
        <button class="arrow left" @click="switchProduct('prev')">
          <img :src="require('@/assets/images/arrow left.png')" alt="上一个" class="arrow-icon" />
        </button>

        <div class="products-display">
          <div class="product-layout">
            <!-- 左侧两列产品 -->
            <div class="left-products">
              <div
                class="product-card"
                v-for="(product, index) in topLeftProducts"
                :key="index"
                :class="{ 'reverse-layout': index === 1 }"
                @click="navigateToProduct(product)"
              >
                <div class="product-content">
                  <div class="product-img-container">
                    <img :src="product.image" :alt="product.title" class="product-img" />
                  </div>
                  <div class="product-text">
                    <h3 class="product-title">{{ product.title }}</h3>
                    <p class="product-desc">{{ product.description }}</p>
                    <button class="card-arrow" type="button">&gt;</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 右侧大产品 -->
            <div class="right-product">
              <div class="product-card large" @click="navigateToProduct(largeProduct)">
                <div class="product-content">
                  <div class="product-img-container">
                    <img :src="largeProduct.image" :alt="largeProduct.title" class="product-img" />
                  </div>
                  <div class="product-text">
                    <h3 class="product-title">{{ largeProduct.title }}</h3>
                    <p class="product-desc">{{ largeProduct.description }}</p>
                    <button class="card-arrow" type="button">&gt;</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="arrow right" @click="switchProduct('next')">
          <img :src="require('@/assets/images/arrow right.png')" alt="下一个" class="arrow-icon" />
        </button>
      </div>
    </div>

  <!-- 创新智造 -->
  <div class="innovation-module scroll-reveal delay-1">
    <div class="module-content">
      <h1 class="module-title">创新智造</h1>
      <div class="module-underline"></div>
      <p class="module-desc">公司多项产品在行业内率先通过欧盟CE及美国FDA认证</p>
      <button class="module-btn" @click="goToInnovativeManufacturing">点击了解更多</button>
    </div>
  </div>

  <div class="carousel scroll-reveal delay-2">
    <!-- 左箭头：点击切换上一项 -->
    <button class="carousel-arrow left" @click="switchCarousel('carousel', 'prev')">
      <img :src="require('@/assets/images/arrow left.png')" alt="上一个" class="arrow-icon" />
    </button>

    <!-- 轮播核心内容：图片 + 文字 -->
    <div class="carousel-content">
      <img :src="currentItem.image" alt="carousel" class="carousel-image" />
      <div class="carousel-text">
        <!-- 标题 -->
        <h3 class="carousel-title">{{ currentItem.title }}</h3>
        <!-- 描述 -->
        <p class="carousel-desc" style="text-align: left">{{ currentItem.desc }}</p>
        <!-- 副标题 -->
        <p class="carousel-subtitle">{{ currentItem.subtitle }}</p>
        <!-- 标签 -->
        <span class="carousel-tag">{{ currentItem.tag }}</span>
      </div>
    </div>

    <!-- 右箭头：点击切换下一项 -->
    <button class="carousel-arrow right" @click="switchCarousel('carousel', 'next')">
      <img :src="require('@/assets/images/arrow right.png')" alt="下一个" class="arrow-icon" />
    </button>
  </div>

  <!-- 资讯中心 -->
  <div class="news-center scroll-reveal">
    <!-- 左侧标题区域 -->
    <div class="news-left">
      <h1 class="news-title">资讯中心</h1>
      <div class="module-underline"></div>
      <p class="news-desc">关注千手医疗最新动态</p>
    </div>
    <!-- 右侧“全部”按钮 -->
    <button class="news-all-btn" @click="goToAllNews">全部</button>
  </div>

  <div class="news-list scroll-reveal delay-1">
    <!-- 左侧：重点新闻卡片 -->
    <div class="news-left">
      <div
        v-if="focusNews"
        class="news-card"
        @click="goToNewsDetail(focusNews)"
        style="cursor: pointer;"
      >
        <img :src="focusNews.image" alt="重点新闻" class="news-image" />
        <h3 class="news-title">{{ focusNews.title }}</h3>
        <p class="news-desc">{{ focusNews.desc }}</p>

        <div class="news-meta">
          <span>日期: {{ focusNews.date }}</span>
          <span v-if="focusNews.region"> | {{ focusNews.region }}</span>
        </div>
      </div>
      <div v-else class="news-card" style="padding: 2rem; color: #999;">暂无资讯</div>
    </div>

    <!-- 右侧：新闻列表 -->
    <div class="news-right">
      <ul class="news-ul">
        <li
          v-for="(news, index) in newsList"
          :key="news.id || index"
          class="news-item"
          @click="goToNewsDetail(news)"
          style="cursor: pointer;"
        >
          <div class="news-meta">
            <span>日期: {{ news.date }}</span>
            <span v-if="news.region"> | {{ news.region }}</span>
          </div>

          <h4 class="news-item-title">{{ news.title }}</h4>
        </li>
      </ul>
    </div>
  </div>

  <!-- 间距分隔 -->
  <div style="margin-bottom: 80px;"></div>


  <!-- 关于我们 -->
  <div class="about-us scroll-reveal">
    <!-- 左侧：企业形象图 -->
    <div class="about-left">
      <img src="../assets/images/homepage/about-us-pic1.png" alt="千手医疗企业大楼" class="about-image" />
      <!-- 底部：企业理念导航 -->
      <div class="about-nav">
        <ul class="nav-list">
          <li v-for="(item, index) in navItems" :key="index" class="nav-item" @click="navigateToAboutTab(item)">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>

    <!-- 右侧：“关于我们”文字与按钮 -->
    <div class="about-right">
      <h2 class="about-title">关于我们</h2>
      <div class="module-underline"></div>
      <p class="about-desc">一家致力于高科技医疗电子产品研发生产及销售服务的高科技企业</p>
      <button class="about-btn" @click="goToDetail">了解详情 →</button>
    </div>
  </div>

  <!-- 间距分隔 -->
  <div style="margin-bottom: 80px;"></div>


  <!-- 用户服务 -->
  <div class="user-service scroll-reveal">
    <!-- 左侧内容区 -->
    <div class="user-service__left">
      <h1 class="user-service__title">用户服务</h1>
      <div class="module-underline"></div>
      <p class="user-service__subtitle">立足全球，共创健康事业，实现卓越成长</p>

      <!-- 间距分隔 -->
      <div style="margin-bottom: 120px;"></div>

      <!-- 质保注册（轮播项内容） -->
      <div class="user-service__item">
        <h3>{{ currentUserserveItem.title }}</h3>
        <p>{{ currentUserserveItem.description }}</p>
        <button class="user-service__btn" @click="goToDetail">了解详情 →</button>
      </div>

      <!-- 切换箭头 -->
      <div class="user-service__arrows">
        <button class="arrow left" @click="switchCarousel('userserve', 'prev')">
          <img :src="require('@/assets/images/arrow left.png')" alt="上一个" class="arrow-icon" />
        </button>
        <button class="arrow right" @click="switchCarousel('userserve', 'next')">
          <img :src="require('@/assets/images/arrow right.png')" alt="下一个" class="arrow-icon" />
        </button>
      </div>
    </div>

    <!-- 右侧图片区 -->
    <div class="user-service__right">
      <img :src="currentUserserveItem.image" alt="服务场景" />
    </div>
  </div>

  <!-- 间距分隔 -->
  <div style="margin-bottom: 80px;"></div>

  <!-- 合作伙伴 -->
  <div class="partner-section scroll-reveal delay-1"
    :style="{ backgroundImage: `url(${require('@/assets/images/product-example.jpg')})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <h2 class="partner-section__title">国内合作伙伴</h2>
    <div class="partner-section__divider"></div>

    <!-- 循环图片路径数组 -->
    <div class="partner-section__list">
      <div v-for="(logo, index) in partnerLogos" :key="index" class="partner-section__item">
        <!--  Logo 图片 -->
        <img :src="logo" alt="合作伙伴logo" class="partner-section__logo" />
      </div>
    </div>
  </div>

    <!-- 底部 -->
    <AppFooter />
  </div>

</template>


<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import { getNewsArticles } from '@/api/newsArticles'
import { formatImg } from '@/utils/formatImg'

export default {
  name: 'HomePage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      productIndex: 0, // 产品轮播的起始索引
      currentIndex: 0, // 创新智造轮播的索引
      userserveIndex: 0, // 用户服务轮播项索引
      animatedElements: [],
      // 关于我们导航项数组
      navItems: ['发展愿景', '发展使命', '经营战略', '核心价值观', '经营理念', '营销理念', '服务理念', '人才理念', '质量方针'],

      // 产品及应用方案
      productList: [
        {
          image: require("@/assets/uploads/hrys/dppfj-001.png"), // 使用require函数处理资源文件
          title: "SMS-3000Ⅰ",
          description: "在医疗机构中使用。绿光用于镇静肌肤，平衡肤色软化角质促进皮肤代谢改善粗糙暗沉；红/黄/蓝光用于炎性痤......",
        },
        {
          image: require("@/assets/uploads/hrys/sppfj-001.png"),
          title: "SMS-6000Ⅰ",
          description: "在医疗机构中使用。绿光用于镇静肌肤，平衡肤色软化角质促进皮肤代谢改善粗糙暗沉；红/黄/蓝光用于炎性痤......",
        },
        {
          image: require("@/assets/uploads/hrys/handheld.jpg"),
          title: "手持式皮肤镜",
          description: "供医疗机构对银屑病、白癜风作辅助治疗用。...",
        },
        {
          image: "https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731164921814.jpg",
          title: "触屏式皮肤镜",
          description: "在医疗机构中用于对体表未染色的上皮细胞及组织在体所成图像进行采集、储存、检索、显示和转换，辅助医生进......",
        },

        {
          image: "https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731164822429.png",
          title: "便携式皮肤镜",
          description: "供医疗机构对银屑病、白癜风作辅助治疗用。...",
        },
        {
          image: "https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731170322849.png",
          title: "言语认知便携式",
          description: "言语/认知康复评估与训练便携方案，含系统软件与平板组件，适合上门服务与社区筛查。...",
        },
        {
          image: require("@/assets/uploads/hrys/skinAnalyzer.png"),
          title: "面部检测仪",
          description: "供医疗机构对银屑病、白癜风作辅助治疗用。...",
        },

        {
          image: require("@/assets/uploads/hrys/ElectronicColonoscopy.png"),
          title: "电子肠镜",
          description: "供医疗机构对银屑病、白癜风作辅助治疗用。...",
        },
        {
          image: "https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731172243424.jpg",
          title: "4K电子阴道显微镜",
          description: "供医疗机构对银屑病、白癜风作辅助治疗用。...",
        },
        // 可继续添加更多产品
      ],

      //  创新智造
      carouselItems: [
        {
          image: require("@/assets/images/homepage/innovation/in-pic1.png"),
          title: "「小实验」这一次的开箱是亲近人类的光",
          desc: "光源500个小时不间断续航压力探索 光源的边界，就是品质的起点",
          subtitle: "智能智造",
          tag: "广告创意",
        },
        {
          image: require("@/assets/images/homepage/innovation/in-pic2.png"),
          title: "科技与生活的融合",
          desc: "更多产品细节与技术突破的探索...",
          subtitle: "未来智造",
          tag: "技术展示",
        },
        // 可继续添加更多轮播项
      ],

      // 资讯中心（接口加载）
      focusNews: null,
      newsList: [],

      // 用户服务
      userserveItem: [
        {
          title: "质保注册",
          description: "欢迎您使用千手医疗产品质保注册功能，仅需要几分钟，为产品进行质保注册，点击了解详情查看。",
          image: require("@/assets/images/homepage/innovation/in-pic1.png"),
        },
        {
          title: "售后服务",
          description: "提供7×24小时专业售后支持，快速响应设备使用、维护等问题。",
          image: require("@/assets/images/homepage/innovation/in-pic2.png"),
        },
      ],

      //合作伙伴logo
      partnerLogos: [
        require("@/assets/uploads/cooperator_logo/tp1.png"),
        require("@/assets/uploads/cooperator_logo/tp2.png"),
        require("@/assets/uploads/cooperator_logo/tp3.png"),
        require("@/assets/uploads/cooperator_logo/tp4.png"),
        require("@/assets/uploads/cooperator_logo/tp5.png"),
        require("@/assets/uploads/cooperator_logo/tp6.png"),
        require("@/assets/uploads/cooperator_logo/tp7.png"),
        require("@/assets/uploads/cooperator_logo/tp8.png"),
        require("@/assets/uploads/cooperator_logo/tp9.png"),
        require("@/assets/uploads/cooperator_logo/tp11.png"),
        require("@/assets/uploads/cooperator_logo/tp12.png"),
        require("@/assets/uploads/cooperator_logo/tp13.png"),
        require("@/assets/uploads/cooperator_logo/tp14.png"),
        require("@/assets/uploads/cooperator_logo/tp15.png"),
        require("@/assets/uploads/cooperator_logo/tp16.png"),

        // 其他 Logo 路径...
      ],

      // 导航栏目：每个栏目包含标题和子项
      navColumns: [
        {
          title: "我们的产品",
          items: ["医学美容", "紫外线光疗仪系列", "LED光谱治疗仪系列", "LLLT激光生发仪系列", "高能红蓝光治疗仪系列", "阴道镜数码成像系统", "家用智能医疗系列", "皮肤毛发观察仪-伍德灯"],
        },
        {
          title: "应用方案",
          items: ["基层皮肤科建设方案", "白癜风光疗解决方案", "毛发专诊建设与管理方案", "光动力疗法及设备方案"],
        },
        {
          title: "创新智造",
          items: ["研发实力", "技术实力", "产品战略", "品牌荣誉"],
        },
        {
          title: "用户服务",
          items: ["质保注册", "授权查询", "联系我们"],
        },
        {
          title: "人才计划",
          items: ["社会人才", "校园人才"],
        },
        {
          title: "关于我们",
          items: ["企业发展", "企业经营", "服务与人才", "质量方针与执行力"],
        },
      ],
      // 社交图标数据已移至AppFooter组件
    };
  },
  computed: {

    // 产品及应用方案
    // 计算左侧上下排列的两个产品
    topLeftProducts() {
      // 获取当前应该显示的两个产品
      const products = [];
      // 循环获取产品，确保即使产品数量不足也能正常工作
      for (let i = 0; i < 2; i++) {
        const index = (this.productIndex + i) % this.productList.length;
        products.push(this.productList[index]);
      }
      return products;
    },
    // 计算右侧大产品
    largeProduct() {
      // 获取右侧大产品，索引为productIndex+2（循环）
      const index = (this.productIndex + 2) % this.productList.length;
      return this.productList[index];
    },


    // 创新智造
    currentItem() {
      return this.carouselItems[this.currentIndex];
    },

    //用户服务
    currentUserserveItem() {
      return this.userserveItem[this.userserveIndex];
    }
  },


  methods: {
    // 关于我们导航跳转
    navigateToAboutTab(item) {
      // 跳转到AboutUs页面，并根据导航项传递相应的标签参数
      let tabType = 'development'; // 默认类型
      let tabIndex = 0;

      // 根据导航项名称确定对应的标签类型和索引
      if (['发展愿景', '发展使命', '经营战略', '核心价值观'].includes(item)) {
        // 企业发展区块的标签
        tabType = 'development';
        // 找到对应的索引
        const devTabNames = ['发展愿景', '发展使命', '经营战略', '核心价值观'];
        tabIndex = devTabNames.indexOf(item);
      } else if (['经营理念', '管理理念'].includes(item)) {
        // 企业经营区块的标签
        tabType = 'operation';
        tabIndex = item === '经营理念' ? 0 : 1;
      } else if (['服务理念', '人才理念'].includes(item)) {
        // 服务与人才区块的标签
        tabType = 'service';
        tabIndex = item === '服务理念' ? 0 : 1;
      } else if (['质量方针', '执行力'].includes(item)) {
        // 质量方针与执行力区块的标签
        tabType = 'quality';
        tabIndex = item === '质量方针' ? 0 : 1;
      }

      // 跳转到AboutUs页面，并传递标签类型和索引作为query参数
      this.$router.push({
        path: '/about-us',
        query: {
          tabType: tabType,
          tabIndex: tabIndex
        }
      });
    },

    // 产品及应用方案
    // 跳转到产品详情页面
    navigateToProduct(product) {
      // 跳转到产品详情页面，并传递产品信息作为参数
      this.$router.push({
        path: '/specific-products',
        query: {
          productTitle: product.title
        }
      });
    },

    //产品及应用方案
    // 切换产品（上一个/下一个）
    switchProduct(direction) {
      // 每页显示3个产品，计算总页数
      const totalPages = Math.ceil(this.productList.length / 3);
      // 当前页码
      const currentPage = Math.floor(this.productIndex / 3);

      let newPage;

      if (direction === "prev") {
        // 向前切换时，如果是第一页则跳转到最后一页
        newPage = (currentPage - 1 + totalPages) % totalPages;
      } else {
        // 向后切换时，如果是最后一页则跳转到第一页
        newPage = (currentPage + 1) % totalPages;
      }

      // 更新productIndex为新页的起始索引
      this.productIndex = newPage * 3;
    },

    // 「了解更多产品」按钮逻辑
    handleMoreProducts() {
      // 先滚动到页面顶部
      window.scrollTo({ top: 0, behavior: 'smooth' });
      // 然后跳转到产品展示页面
      this.$router.push('/product-application');
    },
    // 「了解更多移动应用」：与点击产品卡片相同的跳转方式
    handleMoreSolutions() {
      this.$router.push({ name: 'FumeiApp' });
    },

    // 跳转到全部资讯页面
    goToAllNews() {
      window.scrollTo(0, 0)
      this.$router.push({ name: 'NewsCenter' })
    },

    // 跳转到新闻详情页
    goToNewsDetail(news) {
      if (!news?.id) return
      window.scrollTo(0, 0)
      this.$router.push({
        name: 'NewsDetail',
        query: { id: news.id }
      })
    },

    mapNewsItem(item) {
      let summary = item.summary || ''
      if (!summary && item.content) {
        try {
          const blocks = typeof item.content === 'string' ? JSON.parse(item.content) : item.content
          if (Array.isArray(blocks)) {
            const firstText = blocks.find((b) => b?.type === 'text' && b.text)
            summary = firstText?.text || ''
          } else {
            summary = String(item.content)
          }
        } catch (e) {
          summary = String(item.content)
        }
      }
      return {
        id: item.id,
        title: item.title || '',
        desc: summary,
        date: item.publishTime ? String(item.publishTime).slice(0, 10) : '',
        region: item.region || '',
        company: item.company || '',
        image: formatImg(item.coverUrl) || require('@/assets/images/homepage/news/news-pic1.jpg')
      }
    },

    async loadNewsArticles() {
      try {
        const data = await getNewsArticles()
        const list = Array.isArray(data) ? data.map(this.mapNewsItem) : []
        this.focusNews = list[0] || null
        this.newsList = list.slice(1, 7)
      } catch (e) {
        console.error('加载首页资讯失败', e)
        this.focusNews = null
        this.newsList = []
      }
    },

    // 跳转到创新智造页面
    goToInnovativeManufacturing() {
      // 直接跳转到页面顶部（无平滑过渡）
      window.scrollTo(0, 0);
      // 然后跳转到创新智造页面
      this.$router.push('/innovative-manufacturing');
    },

    // 了解详情：跳转关于我们
    goToDetail() {
      window.scrollTo(0, 0);
      this.$router.push('/about-us');
    },

    // 通用轮播切换方法
    switchCarousel(type, direction) {
      if (type === 'carousel') {
        // 创新智造轮播
        if (direction === 'prev') {
          this.currentIndex = (this.currentIndex - 1 + this.carouselItems.length) % this.carouselItems.length;
        } else {
          this.currentIndex = (this.currentIndex + 1) % this.carouselItems.length;
        }
      } else if (type === 'userserve') {
        // 用户服务轮播
        if (direction === 'prev') {
          this.userserveIndex = (this.userserveIndex - 1 + this.userserveItem.length) % this.userserveItem.length;
        } else {
          this.userserveIndex = (this.userserveIndex + 1) % this.userserveItem.length;
        }
      }
    },

    // 与产品页/肤美页一致的滚动入场动画
    initScrollReveal() {
      this.$nextTick(() => {
        this.animatedElements = Array.from(
          this.$el.querySelectorAll('.scroll-reveal')
        )
        this.animatedElements.forEach((el) => {
          el.classList.remove('active')
          delete el.dataset.revealing
        })
        this.checkScrollReveal()
        window.addEventListener('scroll', this.handleScrollReveal)
        window.addEventListener('resize', this.handleScrollReveal)
      })
    },

    handleScrollReveal() {
      this.checkScrollReveal()
    },

    checkScrollReveal() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const revealPoint = 100
      let batchIndex = 0

      this.animatedElements.forEach((element) => {
        if (!element || element.classList.contains('active') || element.dataset.revealing) return

        const elementTop = element.getBoundingClientRect().top
        if (elementTop < windowHeight - revealPoint) {
          element.dataset.revealing = '1'
          const delay = batchIndex * 250
          batchIndex += 1
          setTimeout(() => {
            element.classList.add('active')
          }, delay)
        }
      })
    },
  },
  mounted() {
    // 进页置顶，再播放错开入场动画（与其他页面一致）
    window.scrollTo({ top: 0, behavior: 'auto' })
    this.loadNewsArticles()
    this.initScrollReveal()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScrollReveal)
    window.removeEventListener('resize', this.handleScrollReveal)
  }
};
</script>
